import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { UserInfoService } from 'src/app/services/auth-service/user-info-service';

@Injectable({ providedIn: 'root' })
export class GlobalAdminGuard implements CanLoad, CanActivate {
  constructor(private readonly router: Router) {}

  async canLoad(_route: Route, _segments: UrlSegment[]): Promise<boolean | UrlTree> {
    return this.check();
  }

  async canActivate(_route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    return this.check();
  }

  private async check(): Promise<boolean | UrlTree> {
    const user = await UserInfoService.getUserInfo();
    return user?.isGlobalAdmin ? true : this.router.parseUrl('/welcome');
  }
}
